import { render, staticRenderFns } from "./navButtons.vue?vue&type=template&id=3b3704fa&scoped=true&"
import script from "./navButtons.vue?vue&type=script&lang=js&"
export * from "./navButtons.vue?vue&type=script&lang=js&"
import style0 from "./navButtons.vue?vue&type=style&index=0&id=3b3704fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3704fa",
  null
  
)

export default component.exports